import { createServerFn } from '@tanstack/react-start';

export const replaceDestinationName = createServerFn({ method: 'POST' })
    .handler(async ({ data }) => {
        const { text, destinationName } = data;
        if (typeof text !== 'string' || !destinationName) return text;
        return text
            .replace(/Maasai Mara/gi, destinationName)
            .replace(/MaasaiMara/gi, destinationName.replace(/\s+/g, ''));
    });